export default __webpack_public_path__ + "static/media/card-theme4.b3a30a0e.svg";